import React from 'react'
import PropTypes from 'prop-types'

import Rating from 'src/ui/Rating/Rating'
import Card from 'src/ui/Card/Card'
import MasonryGrid from 'src/ui/MasonryGrid/MasonryGrid'
import ActivityLabel from 'src/ui/ActivityLabel/ActivityLabel'

const MediaCatalog = ({ items }) => {
  const renderGridContent = (item) => {
    const { mediaKind, title, coverImageUrl, rating, linkToItem } = item

    return (
      <Card
        label={
          <ActivityLabel
            type={
              mediaKind === 'youtube'
                ? 'video'
                : mediaKind === 'audio-file'
                ? 'audio'
                : 'reading'
            }
          />
        }
        footer={rating && <Rating rating={rating} numOfStars={4} />}
        title={title}
        aspectRatio="2:1"
        imgUrl={coverImageUrl}
        linkUrl={linkToItem}
      />
    )
  }
  return <MasonryGrid items={items} renderGridContent={renderGridContent} />
}

MediaCatalog.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ),
}

export default MediaCatalog
